// Above this value of data points, we switch to a faster rendering mode for performance reasons
export const PERFORMANCE_POINT_COUNT_THRESHOLD = 5000;
